import React from 'react';
import { useFormikContext } from 'formik';
import type { LinkInBio } from '@repo/lib';
import { Badge } from '@dashboard/components/ui/badge';
import { Button } from '@dashboard/components/ui/button';
import LinkInBioShareButton from './LinkInBioShareButton';

export function getPublishStatus(savedPublished: boolean, dirty: boolean) {
  if (!savedPublished) return { label: 'Draft', variant: 'info' as const };
  if (dirty) return { label: 'Unpublished changes', variant: 'warning' as const };
  return { label: 'Live', variant: 'success' as const };
}

export default function PublishActions({ savedPublished }: { savedPublished: boolean }) {
  const { dirty, isSubmitting, setFieldValue, submitForm } = useFormikContext<LinkInBio>();
  const status = getPublishStatus(savedPublished, dirty);

  const submitAs = async (published: boolean) => {
    await setFieldValue('published', published, false);
    await submitForm();
  };

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Badge variant={status.variant} className="hidden sm:inline-flex">
        {status.label}
      </Badge>
      {savedPublished ? (
        <>
          <Button
            type="button"
            variant="outline"
            disabled={isSubmitting}
            onClick={() => submitAs(false)}
          >
            Unpublish
          </Button>
          <Button type="button" disabled={!dirty || isSubmitting} onClick={() => submitAs(true)}>
            {isSubmitting ? 'Publishing...' : 'Publish changes'}
          </Button>
        </>
      ) : (
        <>
          <Button
            type="button"
            variant="outline"
            disabled={!dirty || isSubmitting}
            onClick={() => submitAs(false)}
          >
            Save draft
          </Button>
          <Button type="button" disabled={isSubmitting} onClick={() => submitAs(true)}>
            {isSubmitting ? 'Publishing...' : 'Publish'}
          </Button>
        </>
      )}
      <LinkInBioShareButton disabled={!savedPublished} />
    </div>
  );
}
